import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
class PostLoginPresenter {
    constructor(usecase, actions, useCasesStream) {
        this.usecase = usecase;
        this.actions = actions;
        this.useCasesStream = useCasesStream;
        this.symbols = [];
    }
    getNFOLive() {
        return new Promise((resolve, reject) => {
            this.usecase.nfoLive.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, null);
        });
    }
    getNetPositions() {
        this.actions.positions.startLoader();
        this.usecase.positions.execute({
            onSuccess: (data) => {
                this.actions.positions.getPositions(data);
                this.actions.positions.stopLoader();
            },
            onError: (error) => {
                this.actions.positions.setError({ isOpen: true, error });
                this.actions.positions.stopLoader();
            },
        }, null);
    }
    saveIndicesData(req) {
        return new Promise((resolve, reject) => {
            this.usecase.saveIndices.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    portfolioCompositionData(req) {
        this.actions.portfolio.startLoader();
        this.usecase.porfolioComposition.execute({
            onSuccess: (data) => {
                this.actions.portfolio.getPortfolio(data);
                this.actions.portfolio.stopLoader();
            },
            onError: (error) => {
                this.actions.portfolio.setError({ isOpen: true, error });
                this.actions.portfolio.stopLoader();
            },
        }, req);
    }
    getContributionData(req) {
        this.actions.contribution.startLoader();
        this.usecase.contribution.execute({
            onSuccess: (data) => {
                this.actions.contribution.getContributionDetails(data);
                this.actions.contribution.stopLoader();
            },
            onError: (error) => {
                this.actions.contribution.setError({ isOpen: true, error });
                this.actions.contribution.stopLoader();
            },
        }, req);
    }
    getIndexDetails() {
        this.actions.indexDetails.startLoader();
        this.usecase.indexDetails.execute({
            onSuccess: (data) => {
                var _a, _b;
                if (((_b = (_a = data === null || data === void 0 ? void 0 : data.userIndices) === null || _a === void 0 ? void 0 : _a.bull) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    this.symbols = data.userIndices.bull
                        .map((data) => data.symbol)
                        .filter((sym) => sym !== "");
                }
                this.actions.indexDetails.getIndexDetails(data);
                this.actions.indexDetails.stopLoader();
            },
            onError: (error) => {
                this.actions.indexDetails.setError({ isOpen: true, error });
                this.actions.indexDetails.stopLoader();
            },
        }, null);
    }
    getIndexStreaming(subscribe) {
        try {
            const symb = subscribe ? this.symbols : [];
            const streamMapKey = [
                streamKeys[0],
                streamKeys[1],
                streamKeys[2],
                streamKeys[3],
            ];
            this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, async (mappedData) => {
                try {
                    if (symb.includes(mappedData.symbol)) {
                        this.actions.indexDetails.updateStream(mappedData);
                    }
                }
                catch (error) {
                    console.log(error);
                }
            }, symb, streamMapKey);
        }
        catch (error) {
            console.log(error);
        }
    }
    getMarketMapPL(req) {
        this.actions.marketMapPL.startLoader();
        this.usecase.marketMapPL.execute({
            onSuccess: (data) => {
                this.actions.marketMapPL.getMarketMapPL(data);
                this.actions.marketMapPL.stopLoader();
            },
            onError: (error) => {
                this.actions.marketMapPL.setError({ isOpen: true, error });
                this.actions.marketMapPL.stopLoader();
            },
        }, req);
    }
    exploreTrading() {
        return new Promise((resolve, reject) => {
            this.usecase.exploreTrading.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, null);
        });
    }
    getServiceList(req) {
        this.actions.serviceList.startLoader();
        this.usecase.serviceList.execute({
            onSuccess: (data) => {
                this.actions.serviceList.getServiceList(data);
                this.actions.serviceList.stopLoader();
            },
            onError: (error) => {
                this.actions.serviceList.setError({ isOpen: true, error });
                this.actions.serviceList.stopLoader();
            },
        }, req);
    }
    getDiversifyPortfolio() {
        this.actions.diversifyPortfolio.startLoader();
        this.usecase.diversifyPortfolio.execute({
            onSuccess: (data) => {
                this.actions.diversifyPortfolio.getDiversifyPortfolio(data);
                this.actions.diversifyPortfolio.stopLoader();
            },
            onError: (error) => {
                this.actions.diversifyPortfolio.setError({ isOpen: true, error });
                this.actions.diversifyPortfolio.stopLoader();
            },
        }, null);
    }
    getAllIndicesList() {
        this.actions.allIndicesList.startLoader();
        this.usecase.allIndicesList.execute({
            onSuccess: (data) => {
                this.actions.allIndicesList.getAllIndicesList(data);
                this.actions.allIndicesList.stopLoader();
            },
            onError: (error) => {
                this.actions.allIndicesList.setError({ isOpen: true, error });
                this.actions.allIndicesList.stopLoader();
            },
        }, null);
    }
    getUpcomingEvents() {
        this.actions.upcomingEvents.startLoader();
        this.usecase.upcomingEvents.execute({
            onSuccess: (data) => {
                this.actions.upcomingEvents.getUpcomingEvents(data);
                this.actions.upcomingEvents.stopLoader();
            },
            onError: (error) => {
                this.actions.upcomingEvents.setError({ isOpen: true, error });
                this.actions.upcomingEvents.stopLoader();
            },
        }, null);
    }
}
export default PostLoginPresenter;
